<div>
  <div class="cameraButton">
    <input #fileInput type="file" accept="image/jpg,image/jpeg" id="cameraInput" data-cy="file_input"
           (change)="onPhotoChange($event)"/>
  </div>
  <button type="button" class="btn btn-secondary btn-lg"  [ngClass]="{'btn-wide' :isWide}" [disabled]="isDisabled" (click)="onTakePhoto()">
    <span *ngIf="!isDisabled">{{titleBtn | translate}}</span>
    <span *ngIf="isDisabled">{{'PHOTO_ANALYZING' | translate}} <i class="fa fa-spinner fa-spin"></i></span>
  </button>
</div>
